const createVoucherFR = {
    key: 'Clé',
    productId: 'ID du produit',
    variantId: 'ID de variante',
    licenseId: 'ID de licence',
    maxSessions: 'Utilisation max.',
    generate: 'Générer la clé'
}

export default createVoucherFR